import { KeySellingPoints } from 'src/app/v1/views/components/KeySellingPoints';

interface PaywallKeySellingPointProps {
  shouldPaywallKeySellingPointBeShown: boolean;
}

export const PaywallKeySellingPoint = ({
  shouldPaywallKeySellingPointBeShown,
}: PaywallKeySellingPointProps) => {
  if (!shouldPaywallKeySellingPointBeShown) {
    return null;
  }
  return <KeySellingPoints />;
};
